export function alphanumericSort<T>(items: T[], valueSelector: (item: T) => string) {
    return items.toSorted((a, b) => alphanumericCompare(valueSelector(a), valueSelector(b)));
}

function alphanumericCompare(a: string, b: string) {
    return a.localeCompare(b, "en", { numeric: true });
}
